<p-menubar id="app-menubar" [model]="navMenuItems" styleClass="wc-d-none wc-d-md-block"></p-menubar>
<div class="btn-sidebar no-btn-border">
	<p-button (click)="showSidebar()" (keydown.enter)="showSidebar()" icon="fa fa-bars"></p-button>
</div>
<p-drawer id="app-sidebar" [(visible)]="sidebarVisible" position="right" [modal]="true">
	<p-panelMenu [model]="navMenuItems" [multiple]="false"></p-panelMenu>
</p-drawer>
